import * as yup from 'yup';

export const SolarFarmSchema = yup.object({
  id: yup.number().defined(),
  uuid: yup.string().defined(),
  latitude: yup.number(),
  longitude: yup.number(),
  org_id: yup.number(),
  creator_id: yup.number(),
  client_org_id: yup.number(),
  name: yup.string().defined(),
  status: yup.number(),
  created_tsecs: yup.number(),
  updated_tsecs: yup.number().nullable(),
  solar_module_id: yup.number().nullable(),
  address: yup.string().nullable(),
  module_layout: yup.string().nullable(),
  module_mount: yup.string().nullable(),
  site_layout: yup.string().nullable(),
  commissioning_tsecs: yup.number().nullable(),
  version: yup.number(),
  source_farm_uuid: yup.string().nullable(),
  size: yup.number().nullable(),
  access_code: yup.string().nullable(),
  ppa_rate: yup.number().nullable(),
  row_child_process_status: yup.string().nullable(),
  site_status: yup.string().nullable(),
  peak_sunlight_hours_annual: yup.number().nullable(),
  ac_size_megawatts: yup.number().nullable(),
  country: yup.string().nullable(),
  state: yup.string().nullable(),
});

export type SolarFarm = yup.InferType<typeof SolarFarmSchema>;
